module.exports = __webpack_public_path__ + "webpc/img/icon_company.7dd26995.png";